/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const NotificationType = {
    Info: 'INFO',
    Warning: 'WARNING',
    Error: 'ERROR'
} as const;
export type NotificationType = typeof NotificationType[keyof typeof NotificationType];


export function instanceOfNotificationType(value: any): boolean {
    for (const key in NotificationType) {
        if (Object.prototype.hasOwnProperty.call(NotificationType, key)) {
            if (NotificationType[key as keyof typeof NotificationType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function NotificationTypeFromJSON(json: any): NotificationType {
    return NotificationTypeFromJSONTyped(json, false);
}

export function NotificationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationType {
    return json as NotificationType;
}

export function NotificationTypeToJSON(value?: NotificationType | null): any {
    return value as any;
}

export function NotificationTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): NotificationType {
    return value as NotificationType;
}

